import api from "../index";

// ** --------- AI Glossary API --------- ** //
// Create a glossary entry
export const createAiGlossary = (values: any) => {
  return api.post("/glossary", values);
};

// Get all glossary entries
export const getAllAiGlossary = () => {
  return api.get("/glossary");
};

// Get all glossary entries paginated search
export const getAllAiGlossaryPaginatedSearch = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(`/glossary/paginated?page=${page}&perPage=${perPage}`);
  } else {
    return await api.get(
      `/glossary/paginated?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get a glossary entry by ID
export const getAiGlossaryById = (id: any) => {
  return api.get(`/glossary/${id}`);
};

// Update a glossary entry by ID
export const updateAiGlossaryById = (id: any, values: any) => {
  return api.put(`/glossary/${id}`, values);
};

// Delete a glossary entry by ID
export const deleteAiGlossaryById = (id: any) => {
  return api.delete(`/glossary/${id}`);
};

// Update glossary entry approval by ID
export const updateAiGlossaryApprovalById = async (id: any, values: any) => {
  return await api.put(`/glossary/approve/${id}`, values);
};

// Upload glossary cover image
export const uploadAiGlossaryCoverImage = async (values: any, config: any) => {
  return await api.post(`/glossary/cover-image`, values, config);
};

// ** --------- AI Glossary Category API --------- ** //
// Create a glossary category
export const createAiGlossaryCategory = async (values: any) => {
  return await api.post("/ai-glossary-category", values);
};

// Get all glossary categories
export const getAllAiGlossaryCategories = async () => {
  return await api.get(`/ai-glossary-categories`);
};

// Get all glossary categories paginated search
export const getAllAiGlossaryCategoriesPaginatedSearch = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/ai-glossary-categories/paginated?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/ai-glossary-categories/paginated?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get a glossary category by id
export const getAiGlossaryCategoryById = async (id: any) => {
  return await api.get(`/ai-glossary-category/${id}`);
};

// Get a glossary category by name
export const getAiGlossaryCategoryByName = async (name: any) => {
  return await api.get(`/ai-glossary-category/by-name/${name}`);
};

// Update a glossary category by id
export const updateAiGlossaryCategoryById = async (id: any, values: any) => {
  return await api.put(`/ai-glossary-category/${id}`, values);
};

// Delete a glossary category by id
export const deleteAiGlossaryCategoryById = async (id: any) => {
  return await api.delete(`/ai-glossary-category/${id}`);
};
